import React from 'react'
import { ReactComponent as LeadIcon } from '../../../images/sold_vehicle_path/lead_icon.svg'
import dayjs from 'dayjs'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'

type SiteVisitStepProps = {
  Time: string
  Site?: string
  Tag?: string
}

export default function SiteVisitStep({
  path,
}: {
  path: SiteVisitStepProps
}): JSX.Element {
  const dealership = useDealership()
  const { t } = useTranslation('pages', {
    keyPrefix: `performance.salePaths.${dealership?.industry || 'automotive'}`,
  })
  return (
    <div
      className={
        'py-3 px-4 rounded-2xl flex-col gap-2 min-w-60 h-80 flex border-2 bg-[#0DBDE3]/20 border-primary-persian-blue'
      }>
      <div className={'flex w-full items-center flex-col gap-2'}>
        <LeadIcon />
        <div className={'mx-auto text-center'}>
          <h3 className={'font-bold text-md text-primary-purple'}>Site Visit</h3>
          <h4 className={'font-regular text-xs text-primary-purple font-medium'}>
            {dayjs(path?.Time).format('MMM D, YYYY - HH:mm:ss')}
          </h4>
        </div>
      </div>
      {path.Tag && (
        <div className="border-t-2 border-primary-purple/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <div className="flex flex-col gap-1 text-primary-purple">
              <span className="font-bold text-sm uppercase">Tag</span>
              <span className="font-semibold text-xs">{path.Tag}</span>
            </div>
          </div>
        </div>
      )}
      {path.Site && (
        <div className="border-t-2 border-primary-purple/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <div className="flex flex-col gap-1 text-primary-purple">
              <span className="font-bold text-sm uppercase">Site</span>
              <span className="font-semibold text-xs">{path.Site}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
